const draws = [
  {
    drawId: 0,
    name: 'Love Heart',
    difficulty: 'easy',
    pixelSize: 10,
    screen: 'any',
    draw: [
      {
        id: '0|0',
        color: 'white',
      },
      {
        id: '0|1',
        color: 'white',
      },
      {
        id: '0|2',
        color: 'white',
      },
      {
        id: '0|3',
        color: 'white',
      },
      {
        id: '0|4',
        color: 'white',
      },
      {
        id: '0|5',
        color: 'white',
      },
      {
        id: '0|6',
        color: 'white',
      },
      {
        id: '0|7',
        color: 'white',
      },
      {
        id: '0|8',
        color: 'white',
      },
      {
        id: '0|9',
        color: 'white',
      },
      {
        id: '1|0',
        color: 'white',
      },
      {
        id: '1|1',
        color: 'white',
      },
      {
        id: '1|2',
        color: 'red',
      },
      {
        id: '1|3',
        color: 'red',
      },
      {
        id: '1|4',
        color: 'white',
      },
      {
        id: '1|5',
        color: 'white',
      },
      {
        id: '1|6',
        color: 'red',
      },
      {
        id: '1|7',
        color: 'red',
      },
      {
        id: '1|8',
        color: 'white',
      },
      {
        id: '1|9',
        color: 'white',
      },
      {
        id: '2|0',
        color: 'white',
      },
      {
        id: '2|1',
        color: 'red',
      },
      {
        id: '2|2',
        color: 'white',
      },
      {
        id: '2|3',
        color: 'white',
      },
      {
        id: '2|4',
        color: 'red',
      },
      {
        id: '2|5',
        color: 'red',
      },
      {
        id: '2|6',
        color: 'red',
      },
      {
        id: '2|7',
        color: 'red',
      },
      {
        id: '2|8',
        color: 'red',
      },
      {
        id: '2|9',
        color: 'white',
      },
      {
        id: '3|0',
        color: 'white',
      },
      {
        id: '3|1',
        color: 'red',
      },
      {
        id: '3|2',
        color: 'white',
      },
      {
        id: '3|3',
        color: 'red',
      },
      {
        id: '3|4',
        color: 'red',
      },
      {
        id: '3|5',
        color: 'red',
      },
      {
        id: '3|6',
        color: 'red',
      },
      {
        id: '3|7',
        color: 'red',
      },
      {
        id: '3|8',
        color: 'red',
      },
      {
        id: '3|9',
        color: 'white',
      },
      {
        id: '4|0',
        color: 'white',
      },
      {
        id: '4|1',
        color: 'red',
      },
      {
        id: '4|2',
        color: 'red',
      },
      {
        id: '4|3',
        color: 'red',
      },
      {
        id: '4|4',
        color: 'red',
      },
      {
        id: '4|5',
        color: 'red',
      },
      {
        id: '4|6',
        color: 'red',
      },
      {
        id: '4|7',
        color: 'red',
      },
      {
        id: '4|8',
        color: 'red',
      },
      {
        id: '4|9',
        color: 'white',
      },
      {
        id: '5|0',
        color: 'white',
      },
      {
        id: '5|1',
        color: 'black',
      },
      {
        id: '5|2',
        color: 'red',
      },
      {
        id: '5|3',
        color: 'red',
      },
      {
        id: '5|4',
        color: 'red',
      },
      {
        id: '5|5',
        color: 'red',
      },
      {
        id: '5|6',
        color: 'red',
      },
      {
        id: '5|7',
        color: 'red',
      },
      {
        id: '5|8',
        color: 'black',
      },
      {
        id: '5|9',
        color: 'white',
      },
      {
        id: '6|0',
        color: 'white',
      },
      {
        id: '6|1',
        color: 'white',
      },
      {
        id: '6|2',
        color: 'black',
      },
      {
        id: '6|3',
        color: 'red',
      },
      {
        id: '6|4',
        color: 'red',
      },
      {
        id: '6|5',
        color: 'red',
      },
      {
        id: '6|6',
        color: 'red',
      },
      {
        id: '6|7',
        color: 'black',
      },
      {
        id: '6|8',
        color: 'white',
      },
      {
        id: '6|9',
        color: 'white',
      },
      {
        id: '7|0',
        color: 'white',
      },
      {
        id: '7|1',
        color: 'white',
      },
      {
        id: '7|2',
        color: 'white',
      },
      {
        id: '7|3',
        color: 'black',
      },
      {
        id: '7|4',
        color: 'red',
      },
      {
        id: '7|5',
        color: 'red',
      },
      {
        id: '7|6',
        color: 'black',
      },
      {
        id: '7|7',
        color: 'white',
      },
      {
        id: '7|8',
        color: 'white',
      },
      {
        id: '7|9',
        color: 'white',
      },
      {
        id: '8|0',
        color: 'white',
      },
      {
        id: '8|1',
        color: 'white',
      },
      {
        id: '8|2',
        color: 'white',
      },
      {
        id: '8|3',
        color: 'white',
      },
      {
        id: '8|4',
        color: 'black',
      },
      {
        id: '8|5',
        color: 'black',
      },
      {
        id: '8|6',
        color: 'white',
      },
      {
        id: '8|7',
        color: 'white',
      },
      {
        id: '8|8',
        color: 'white',
      },
      {
        id: '8|9',
        color: 'white',
      },
      {
        id: '9|0',
        color: 'white',
      },
      {
        id: '9|1',
        color: 'white',
      },
      {
        id: '9|2',
        color: 'white',
      },
      {
        id: '9|3',
        color: 'white',
      },
      {
        id: '9|4',
        color: 'white',
      },
      {
        id: '9|5',
        color: 'white',
      },
      {
        id: '9|6',
        color: 'white',
      },
      {
        id: '9|7',
        color: 'white',
      },
      {
        id: '9|8',
        color: 'white',
      },
      {
        id: '9|9',
        color: 'white',
      },
    ],
  },
  {
    drawId: 1,
    name: 'Pokéball',
    difficulty: 'easy',
    pixelSize: 10,
    screen: 'any',
    draw: [
      {
        id: '0|0',
        color: 'white',
      },
      {
        id: '0|1',
        color: 'white',
      },
      {
        id: '0|2',
        color: 'white',
      },
      {
        id: '0|3',
        color: 'white',
      },
      {
        id: '0|4',
        color: 'white',
      },
      {
        id: '0|5',
        color: 'white',
      },
      {
        id: '0|6',
        color: 'white',
      },
      {
        id: '0|7',
        color: 'white',
      },
      {
        id: '0|8',
        color: 'white',
      },
      {
        id: '0|9',
        color: 'white',
      },
      {
        id: '1|0',
        color: 'white',
      },
      {
        id: '1|1',
        color: 'white',
      },
      {
        id: '1|2',
        color: 'white',
      },
      {
        id: '1|3',
        color: 'black',
      },
      {
        id: '1|4',
        color: 'black',
      },
      {
        id: '1|5',
        color: 'black',
      },
      {
        id: '1|6',
        color: 'black',
      },
      {
        id: '1|7',
        color: 'white',
      },
      {
        id: '1|8',
        color: 'white',
      },
      {
        id: '1|9',
        color: 'white',
      },
      {
        id: '2|0',
        color: 'white',
      },
      {
        id: '2|1',
        color: 'white',
      },
      {
        id: '2|2',
        color: 'black',
      },
      {
        id: '2|3',
        color: 'red',
      },
      {
        id: '2|4',
        color: 'red',
      },
      {
        id: '2|5',
        color: 'red',
      },
      {
        id: '2|6',
        color: 'red',
      },
      {
        id: '2|7',
        color: 'black',
      },
      {
        id: '2|8',
        color: 'white',
      },
      {
        id: '2|9',
        color: 'white',
      },
      {
        id: '3|0',
        color: 'white',
      },
      {
        id: '3|1',
        color: 'black',
      },
      {
        id: '3|2',
        color: 'red',
      },
      {
        id: '3|3',
        color: 'red',
      },
      {
        id: '3|4',
        color: 'red',
      },
      {
        id: '3|5',
        color: 'red',
      },
      {
        id: '3|6',
        color: 'red',
      },
      {
        id: '3|7',
        color: 'red',
      },
      {
        id: '3|8',
        color: 'black',
      },
      {
        id: '3|9',
        color: 'white',
      },
      {
        id: '4|0',
        color: 'white',
      },
      {
        id: '4|1',
        color: 'black',
      },
      {
        id: '4|2',
        color: 'red',
      },
      {
        id: '4|3',
        color: 'red',
      },
      {
        id: '4|4',
        color: 'black',
      },
      {
        id: '4|5',
        color: 'black',
      },
      {
        id: '4|6',
        color: 'red',
      },
      {
        id: '4|7',
        color: 'red',
      },
      {
        id: '4|8',
        color: 'black',
      },
      {
        id: '4|9',
        color: 'white',
      },
      {
        id: '5|0',
        color: 'white',
      },
      {
        id: '5|1',
        color: 'black',
      },
      {
        id: '5|2',
        color: 'black',
      },
      {
        id: '5|3',
        color: 'black',
      },
      {
        id: '5|4',
        color: 'white',
      },
      {
        id: '5|5',
        color: 'white',
      },
      {
        id: '5|6',
        color: 'black',
      },
      {
        id: '5|7',
        color: 'black',
      },
      {
        id: '5|8',
        color: 'black',
      },
      {
        id: '5|9',
        color: 'white',
      },
      {
        id: '6|0',
        color: 'white',
      },
      {
        id: '6|1',
        color: 'black',
      },
      {
        id: '6|2',
        color: 'white',
      },
      {
        id: '6|3',
        color: 'white',
      },
      {
        id: '6|4',
        color: 'black',
      },
      {
        id: '6|5',
        color: 'black',
      },
      {
        id: '6|6',
        color: 'white',
      },
      {
        id: '6|7',
        color: 'white',
      },
      {
        id: '6|8',
        color: 'black',
      },
      {
        id: '6|9',
        color: 'white',
      },
      {
        id: '7|0',
        color: 'white',
      },
      {
        id: '7|1',
        color: 'white',
      },
      {
        id: '7|2',
        color: 'black',
      },
      {
        id: '7|3',
        color: 'white',
      },
      {
        id: '7|4',
        color: 'white',
      },
      {
        id: '7|5',
        color: 'white',
      },
      {
        id: '7|6',
        color: 'white',
      },
      {
        id: '7|7',
        color: 'black',
      },
      {
        id: '7|8',
        color: 'white',
      },
      {
        id: '7|9',
        color: 'white',
      },
      {
        id: '8|0',
        color: 'white',
      },
      {
        id: '8|1',
        color: 'white',
      },
      {
        id: '8|2',
        color: 'white',
      },
      {
        id: '8|3',
        color: 'black',
      },
      {
        id: '8|4',
        color: 'black',
      },
      {
        id: '8|5',
        color: 'black',
      },
      {
        id: '8|6',
        color: 'black',
      },
      {
        id: '8|7',
        color: 'white',
      },
      {
        id: '8|8',
        color: 'white',
      },
      {
        id: '8|9',
        color: 'white',
      },
      {
        id: '9|0',
        color: 'white',
      },
      {
        id: '9|1',
        color: 'white',
      },
      {
        id: '9|2',
        color: 'white',
      },
      {
        id: '9|3',
        color: 'white',
      },
      {
        id: '9|4',
        color: 'white',
      },
      {
        id: '9|5',
        color: 'white',
      },
      {
        id: '9|6',
        color: 'white',
      },
      {
        id: '9|7',
        color: 'white',
      },
      {
        id: '9|8',
        color: 'white',
      },
      {
        id: '9|9',
        color: 'white',
      },
    ],
  },
  {
    drawId: 2,
    name: 'Pac-Man Ghost',
    difficulty: 'easy',
    pixelSize: 10,
    screen: 'any',
    draw: [
      {
        id: '0|0',
        color: 'white',
      },
      {
        id: '0|1',
        color: 'white',
      },
      {
        id: '0|2',
        color: 'white',
      },
      {
        id: '0|3',
        color: 'white',
      },
      {
        id: '0|4',
        color: 'white',
      },
      {
        id: '0|5',
        color: 'white',
      },
      {
        id: '0|6',
        color: 'white',
      },
      {
        id: '0|7',
        color: 'white',
      },
      {
        id: '0|8',
        color: 'white',
      },
      {
        id: '0|9',
        color: 'white',
      },
      {
        id: '1|0',
        color: 'white',
      },
      {
        id: '1|1',
        color: 'white',
      },
      {
        id: '1|2',
        color: 'white',
      },
      {
        id: '1|3',
        color: 'blue',
      },
      {
        id: '1|4',
        color: 'blue',
      },
      {
        id: '1|5',
        color: 'blue',
      },
      {
        id: '1|6',
        color: 'blue',
      },
      {
        id: '1|7',
        color: 'white',
      },
      {
        id: '1|8',
        color: 'white',
      },
      {
        id: '1|9',
        color: 'white',
      },
      {
        id: '2|0',
        color: 'white',
      },
      {
        id: '2|1',
        color: 'white',
      },
      {
        id: '2|2',
        color: 'blue',
      },
      {
        id: '2|3',
        color: 'blue',
      },
      {
        id: '2|4',
        color: 'blue',
      },
      {
        id: '2|5',
        color: 'blue',
      },
      {
        id: '2|6',
        color: 'blue',
      },
      {
        id: '2|7',
        color: 'blue',
      },
      {
        id: '2|8',
        color: 'white',
      },
      {
        id: '2|9',
        color: 'white',
      },
      {
        id: '3|0',
        color: 'white',
      },
      {
        id: '3|1',
        color: 'blue',
      },
      {
        id: '3|2',
        color: 'blue',
      },
      {
        id: '3|3',
        color: 'white',
      },
      {
        id: '3|4',
        color: 'white',
      },
      {
        id: '3|5',
        color: 'blue',
      },
      {
        id: '3|6',
        color: 'white',
      },
      {
        id: '3|7',
        color: 'white',
      },
      {
        id: '3|8',
        color: 'blue',
      },
      {
        id: '3|9',
        color: 'white',
      },
      {
        id: '4|0',
        color: 'white',
      },
      {
        id: '4|1',
        color: 'blue',
      },
      {
        id: '4|2',
        color: 'blue',
      },
      {
        id: '4|3',
        color: 'white',
      },
      {
        id: '4|4',
        color: 'black',
      },
      {
        id: '4|5',
        color: 'blue',
      },
      {
        id: '4|6',
        color: 'white',
      },
      {
        id: '4|7',
        color: 'black',
      },
      {
        id: '4|8',
        color: 'blue',
      },
      {
        id: '4|9',
        color: 'white',
      },
      {
        id: '5|0',
        color: 'white',
      },
      {
        id: '5|1',
        color: 'blue',
      },
      {
        id: '5|2',
        color: 'blue',
      },
      {
        id: '5|3',
        color: 'blue',
      },
      {
        id: '5|4',
        color: 'blue',
      },
      {
        id: '5|5',
        color: 'blue',
      },
      {
        id: '5|6',
        color: 'blue',
      },
      {
        id: '5|7',
        color: 'blue',
      },
      {
        id: '5|8',
        color: 'blue',
      },
      {
        id: '5|9',
        color: 'white',
      },
      {
        id: '6|0',
        color: 'white',
      },
      {
        id: '6|1',
        color: 'blue',
      },
      {
        id: '6|2',
        color: 'blue',
      },
      {
        id: '6|3',
        color: 'blue',
      },
      {
        id: '6|4',
        color: 'blue',
      },
      {
        id: '6|5',
        color: 'blue',
      },
      {
        id: '6|6',
        color: 'blue',
      },
      {
        id: '6|7',
        color: 'blue',
      },
      {
        id: '6|8',
        color: 'blue',
      },
      {
        id: '6|9',
        color: 'white',
      },
      {
        id: '7|0',
        color: 'white',
      },
      {
        id: '7|1',
        color: 'blue',
      },
      {
        id: '7|2',
        color: 'blue',
      },
      {
        id: '7|3',
        color: 'blue',
      },
      {
        id: '7|4',
        color: 'blue',
      },
      {
        id: '7|5',
        color: 'blue',
      },
      {
        id: '7|6',
        color: 'blue',
      },
      {
        id: '7|7',
        color: 'blue',
      },
      {
        id: '7|8',
        color: 'blue',
      },
      {
        id: '7|9',
        color: 'white',
      },
      {
        id: '8|0',
        color: 'white',
      },
      {
        id: '8|1',
        color: 'blue',
      },
      {
        id: '8|2',
        color: 'blue',
      },
      {
        id: '8|3',
        color: 'white',
      },
      {
        id: '8|4',
        color: 'blue',
      },
      {
        id: '8|5',
        color: 'blue',
      },
      {
        id: '8|6',
        color: 'white',
      },
      {
        id: '8|7',
        color: 'blue',
      },
      {
        id: '8|8',
        color: 'blue',
      },
      {
        id: '8|9',
        color: 'white',
      },
      {
        id: '9|0',
        color: 'white',
      },
      {
        id: '9|1',
        color: 'white',
      },
      {
        id: '9|2',
        color: 'white',
      },
      {
        id: '9|3',
        color: 'white',
      },
      {
        id: '9|4',
        color: 'white',
      },
      {
        id: '9|5',
        color: 'white',
      },
      {
        id: '9|6',
        color: 'white',
      },
      {
        id: '9|7',
        color: 'white',
      },
      {
        id: '9|8',
        color: 'white',
      },
      {
        id: '9|9',
        color: 'white',
      },
    ],
  },
  {
    drawId: 3,
    name: 'Punisher Skull',
    difficulty: 'medium',
    pixelSize: 10,
    screen: 'any',
    draw: [
      {
        id: '0|0',
        color: 'black',
      },
      {
        id: '0|1',
        color: 'black',
      },
      {
        id: '0|2',
        color: 'black',
      },
      {
        id: '0|3',
        color: 'black',
      },
      {
        id: '0|4',
        color: 'black',
      },
      {
        id: '0|5',
        color: 'black',
      },
      {
        id: '0|6',
        color: 'black',
      },
      {
        id: '0|7',
        color: 'black',
      },
      {
        id: '0|8',
        color: 'black',
      },
      {
        id: '0|9',
        color: 'black',
      },
      {
        id: '1|0',
        color: 'black',
      },
      {
        id: '1|1',
        color: 'white',
      },
      {
        id: '1|2',
        color: 'white',
      },
      {
        id: '1|3',
        color: 'white',
      },
      {
        id: '1|4',
        color: 'white',
      },
      {
        id: '1|5',
        color: 'white',
      },
      {
        id: '1|6',
        color: 'white',
      },
      {
        id: '1|7',
        color: 'white',
      },
      {
        id: '1|8',
        color: 'white',
      },
      {
        id: '1|9',
        color: 'black',
      },
      {
        id: '2|0',
        color: 'black',
      },
      {
        id: '2|1',
        color: 'white',
      },
      {
        id: '2|2',
        color: 'black',
      },
      {
        id: '2|3',
        color: 'black',
      },
      {
        id: '2|4',
        color: 'white',
      },
      {
        id: '2|5',
        color: 'white',
      },
      {
        id: '2|6',
        color: 'black',
      },
      {
        id: '2|7',
        color: 'black',
      },
      {
        id: '2|8',
        color: 'white',
      },
      {
        id: '2|9',
        color: 'black',
      },
      {
        id: '3|0',
        color: 'black',
      },
      {
        id: '3|1',
        color: 'white',
      },
      {
        id: '3|2',
        color: 'black',
      },
      {
        id: '3|3',
        color: 'black',
      },
      {
        id: '3|4',
        color: 'white',
      },
      {
        id: '3|5',
        color: 'white',
      },
      {
        id: '3|6',
        color: 'black',
      },
      {
        id: '3|7',
        color: 'black',
      },
      {
        id: '3|8',
        color: 'white',
      },
      {
        id: '3|9',
        color: 'black',
      },
      {
        id: '4|0',
        color: 'black',
      },
      {
        id: '4|1',
        color: 'white',
      },
      {
        id: '4|2',
        color: 'white',
      },
      {
        id: '4|3',
        color: 'white',
      },
      {
        id: '4|4',
        color: 'white',
      },
      {
        id: '4|5',
        color: 'white',
      },
      {
        id: '4|6',
        color: 'white',
      },
      {
        id: '4|7',
        color: 'white',
      },
      {
        id: '4|8',
        color: 'white',
      },
      {
        id: '4|9',
        color: 'black',
      },
      {
        id: '5|0',
        color: 'black',
      },
      {
        id: '5|1',
        color: 'white',
      },
      {
        id: '5|2',
        color: 'white',
      },
      {
        id: '5|3',
        color: 'white',
      },
      {
        id: '5|4',
        color: 'black',
      },
      {
        id: '5|5',
        color: 'black',
      },
      {
        id: '5|6',
        color: 'white',
      },
      {
        id: '5|7',
        color: 'white',
      },
      {
        id: '5|8',
        color: 'white',
      },
      {
        id: '5|9',
        color: 'black',
      },
      {
        id: '6|0',
        color: 'black',
      },
      {
        id: '6|1',
        color: 'black',
      },
      {
        id: '6|2',
        color: 'white',
      },
      {
        id: '6|3',
        color: 'white',
      },
      {
        id: '6|4',
        color: 'white',
      },
      {
        id: '6|5',
        color: 'white',
      },
      {
        id: '6|6',
        color: 'white',
      },
      {
        id: '6|7',
        color: 'white',
      },
      {
        id: '6|8',
        color: 'black',
      },
      {
        id: '6|9',
        color: 'black',
      },
      {
        id: '7|0',
        color: 'black',
      },
      {
        id: '7|1',
        color: 'black',
      },
      {
        id: '7|2',
        color: 'white',
      },
      {
        id: '7|3',
        color: 'white',
      },
      {
        id: '7|4',
        color: 'white',
      },
      {
        id: '7|5',
        color: 'white',
      },
      {
        id: '7|6',
        color: 'white',
      },
      {
        id: '7|7',
        color: 'white',
      },
      {
        id: '7|8',
        color: 'black',
      },
      {
        id: '7|9',
        color: 'black',
      },
      {
        id: '8|0',
        color: 'black',
      },
      {
        id: '8|1',
        color: 'black',
      },
      {
        id: '8|2',
        color: 'white',
      },
      {
        id: '8|3',
        color: 'black',
      },
      {
        id: '8|4',
        color: 'white',
      },
      {
        id: '8|5',
        color: 'white',
      },
      {
        id: '8|6',
        color: 'black',
      },
      {
        id: '8|7',
        color: 'white',
      },
      {
        id: '8|8',
        color: 'black',
      },
      {
        id: '8|9',
        color: 'black',
      },
      {
        id: '9|0',
        color: 'black',
      },
      {
        id: '9|1',
        color: 'black',
      },
      {
        id: '9|2',
        color: 'black',
      },
      {
        id: '9|3',
        color: 'black',
      },
      {
        id: '9|4',
        color: 'black',
      },
      {
        id: '9|5',
        color: 'black',
      },
      {
        id: '9|6',
        color: 'black',
      },
      {
        id: '9|7',
        color: 'black',
      },
      {
        id: '9|8',
        color: 'black',
      },
      {
        id: '9|9',
        color: 'black',
      },
    ],
  },
  {
    drawId: 4,
    name: 'Mario Mushroom',
    difficulty: 'medium',
    pixelSize: 12,
    screen: 'desktop',
    draw: [
      {
        id: '0|0',
        color: 'white',
      },
      {
        id: '0|1',
        color: 'white',
      },
      {
        id: '0|2',
        color: 'white',
      },
      {
        id: '0|3',
        color: 'white',
      },
      {
        id: '0|4',
        color: 'white',
      },
      {
        id: '0|5',
        color: 'white',
      },
      {
        id: '0|6',
        color: 'white',
      },
      {
        id: '0|7',
        color: 'white',
      },
      {
        id: '0|8',
        color: 'white',
      },
      {
        id: '0|9',
        color: 'white',
      },
      {
        id: '0|10',
        color: 'white',
      },
      {
        id: '0|11',
        color: 'white',
      },
      {
        id: '1|0',
        color: 'white',
      },
      {
        id: '1|1',
        color: 'white',
      },
      {
        id: '1|2',
        color: 'white',
      },
      {
        id: '1|3',
        color: 'black',
      },
      {
        id: '1|4',
        color: 'black',
      },
      {
        id: '1|5',
        color: 'black',
      },
      {
        id: '1|6',
        color: 'black',
      },
      {
        id: '1|7',
        color: 'black',
      },
      {
        id: '1|8',
        color: 'black',
      },
      {
        id: '1|9',
        color: 'white',
      },
      {
        id: '1|10',
        color: 'white',
      },
      {
        id: '1|11',
        color: 'white',
      },
      {
        id: '2|0',
        color: 'white',
      },
      {
        id: '2|1',
        color: 'white',
      },
      {
        id: '2|2',
        color: 'black',
      },
      {
        id: '2|3',
        color: 'red',
      },
      {
        id: '2|4',
        color: 'red',
      },
      {
        id: '2|5',
        color: 'red',
      },
      {
        id: '2|6',
        color: 'red',
      },
      {
        id: '2|7',
        color: 'red',
      },
      {
        id: '2|8',
        color: 'white',
      },
      {
        id: '2|9',
        color: 'black',
      },
      {
        id: '2|10',
        color: 'white',
      },
      {
        id: '2|11',
        color: 'white',
      },
      {
        id: '3|0',
        color: 'white',
      },
      {
        id: '3|1',
        color: 'black',
      },
      {
        id: '3|2',
        color: 'red',
      },
      {
        id: '3|3',
        color: 'red',
      },
      {
        id: '3|4',
        color: 'red',
      },
      {
        id: '3|5',
        color: 'white',
      },
      {
        id: '3|6',
        color: 'white',
      },
      {
        id: '3|7',
        color: 'red',
      },
      {
        id: '3|8',
        color: 'white',
      },
      {
        id: '3|9',
        color: 'white',
      },
      {
        id: '3|10',
        color: 'black',
      },
      {
        id: '3|11',
        color: 'white',
      },
      {
        id: '4|0',
        color: 'white',
      },
      {
        id: '4|1',
        color: 'black',
      },
      {
        id: '4|2',
        color: 'red',
      },
      {
        id: '4|3',
        color: 'red',
      },
      {
        id: '4|4',
        color: 'red',
      },
      {
        id: '4|5',
        color: 'white',
      },
      {
        id: '4|6',
        color: 'white',
      },
      {
        id: '4|7',
        color: 'red',
      },
      {
        id: '4|8',
        color: 'red',
      },
      {
        id: '4|9',
        color: 'red',
      },
      {
        id: '4|10',
        color: 'black',
      },
      {
        id: '4|11',
        color: 'white',
      },
      {
        id: '5|0',
        color: 'white',
      },
      {
        id: '5|1',
        color: 'black',
      },
      {
        id: '5|2',
        color: 'white',
      },
      {
        id: '5|3',
        color: 'red',
      },
      {
        id: '5|4',
        color: 'red',
      },
      {
        id: '5|5',
        color: 'red',
      },
      {
        id: '5|6',
        color: 'red',
      },
      {
        id: '5|7',
        color: 'red',
      },
      {
        id: '5|8',
        color: 'white',
      },
      {
        id: '5|9',
        color: 'red',
      },
      {
        id: '5|10',
        color: 'black',
      },
      {
        id: '5|11',
        color: 'white',
      },
      {
        id: '6|0',
        color: 'white',
      },
      {
        id: '6|1',
        color: 'black',
      },
      {
        id: '6|2',
        color: 'white',
      },
      {
        id: '6|3',
        color: 'white',
      },
      {
        id: '6|4',
        color: 'red',
      },
      {
        id: '6|5',
        color: 'red',
      },
      {
        id: '6|6',
        color: 'red',
      },
      {
        id: '6|7',
        color: 'red',
      },
      {
        id: '6|8',
        color: 'red',
      },
      {
        id: '6|9',
        color: 'red',
      },
      {
        id: '6|10',
        color: 'black',
      },
      {
        id: '6|11',
        color: 'white',
      },
      {
        id: '7|0',
        color: 'white',
      },
      {
        id: '7|1',
        color: 'black',
      },
      {
        id: '7|2',
        color: 'black',
      },
      {
        id: '7|3',
        color: 'white',
      },
      {
        id: '7|4',
        color: 'black',
      },
      {
        id: '7|5',
        color: 'white',
      },
      {
        id: '7|6',
        color: 'white',
      },
      {
        id: '7|7',
        color: 'black',
      },
      {
        id: '7|8',
        color: 'white',
      },
      {
        id: '7|9',
        color: 'black',
      },
      {
        id: '7|10',
        color: 'black',
      },
      {
        id: '7|11',
        color: 'white',
      },
      {
        id: '8|0',
        color: 'white',
      },
      {
        id: '8|1',
        color: 'white',
      },
      {
        id: '8|2',
        color: 'black',
      },
      {
        id: '8|3',
        color: 'white',
      },
      {
        id: '8|4',
        color: 'black',
      },
      {
        id: '8|5',
        color: 'white',
      },
      {
        id: '8|6',
        color: 'white',
      },
      {
        id: '8|7',
        color: 'black',
      },
      {
        id: '8|8',
        color: 'white',
      },
      {
        id: '8|9',
        color: 'black',
      },
      {
        id: '8|10',
        color: 'white',
      },
      {
        id: '8|11',
        color: 'white',
      },
      {
        id: '9|0',
        color: 'white',
      },
      {
        id: '9|1',
        color: 'white',
      },
      {
        id: '9|2',
        color: 'black',
      },
      {
        id: '9|3',
        color: 'white',
      },
      {
        id: '9|4',
        color: 'white',
      },
      {
        id: '9|5',
        color: 'white',
      },
      {
        id: '9|6',
        color: 'white',
      },
      {
        id: '9|7',
        color: 'white',
      },
      {
        id: '9|8',
        color: 'white',
      },
      {
        id: '9|9',
        color: 'black',
      },
      {
        id: '9|10',
        color: 'white',
      },
      {
        id: '9|11',
        color: 'white',
      },
      {
        id: '10|0',
        color: 'white',
      },
      {
        id: '10|1',
        color: 'white',
      },
      {
        id: '10|2',
        color: 'black',
      },
      {
        id: '10|3',
        color: 'black',
      },
      {
        id: '10|4',
        color: 'black',
      },
      {
        id: '10|5',
        color: 'black',
      },
      {
        id: '10|6',
        color: 'black',
      },
      {
        id: '10|7',
        color: 'black',
      },
      {
        id: '10|8',
        color: 'black',
      },
      {
        id: '10|9',
        color: 'black',
      },
      {
        id: '10|10',
        color: 'white',
      },
      {
        id: '10|11',
        color: 'white',
      },
      {
        id: '11|0',
        color: 'white',
      },
      {
        id: '11|1',
        color: 'white',
      },
      {
        id: '11|2',
        color: 'white',
      },
      {
        id: '11|3',
        color: 'white',
      },
      {
        id: '11|4',
        color: 'white',
      },
      {
        id: '11|5',
        color: 'white',
      },
      {
        id: '11|6',
        color: 'white',
      },
      {
        id: '11|7',
        color: 'white',
      },
      {
        id: '11|8',
        color: 'white',
      },
      {
        id: '11|9',
        color: 'white',
      },
      {
        id: '11|10',
        color: 'white',
      },
      {
        id: '11|11',
        color: 'white',
      },
    ],
  },
  {
    drawId: 5,
    name: 'Mario Star',
    difficulty: 'hard',
    pixelSize: 16,
    screen: 'desktop',
    draw: [
      {
        id: '0|0',
        color: 'white',
      },
      {
        id: '0|1',
        color: 'white',
      },
      {
        id: '0|2',
        color: 'white',
      },
      {
        id: '0|3',
        color: 'white',
      },
      {
        id: '0|4',
        color: 'white',
      },
      {
        id: '0|5',
        color: 'white',
      },
      {
        id: '0|6',
        color: 'white',
      },
      {
        id: '0|7',
        color: 'white',
      },
      {
        id: '0|8',
        color: 'white',
      },
      {
        id: '0|9',
        color: 'white',
      },
      {
        id: '0|10',
        color: 'white',
      },
      {
        id: '0|11',
        color: 'white',
      },
      {
        id: '0|12',
        color: 'white',
      },
      {
        id: '0|13',
        color: 'white',
      },
      {
        id: '0|14',
        color: 'white',
      },
      {
        id: '0|15',
        color: 'white',
      },
      {
        id: '1|0',
        color: 'white',
      },
      {
        id: '1|1',
        color: 'white',
      },
      {
        id: '1|2',
        color: 'white',
      },
      {
        id: '1|3',
        color: 'white',
      },
      {
        id: '1|4',
        color: 'white',
      },
      {
        id: '1|5',
        color: 'white',
      },
      {
        id: '1|6',
        color: 'white',
      },
      {
        id: '1|7',
        color: 'black',
      },
      {
        id: '1|8',
        color: 'black',
      },
      {
        id: '1|9',
        color: 'white',
      },
      {
        id: '1|10',
        color: 'white',
      },
      {
        id: '1|11',
        color: 'white',
      },
      {
        id: '1|12',
        color: 'white',
      },
      {
        id: '1|13',
        color: 'white',
      },
      {
        id: '1|14',
        color: 'white',
      },
      {
        id: '1|15',
        color: 'white',
      },
      {
        id: '2|0',
        color: 'white',
      },
      {
        id: '2|1',
        color: 'white',
      },
      {
        id: '2|2',
        color: 'white',
      },
      {
        id: '2|3',
        color: 'white',
      },
      {
        id: '2|4',
        color: 'white',
      },
      {
        id: '2|5',
        color: 'white',
      },
      {
        id: '2|6',
        color: 'black',
      },
      {
        id: '2|7',
        color: 'yellow',
      },
      {
        id: '2|8',
        color: 'yellow',
      },
      {
        id: '2|9',
        color: 'black',
      },
      {
        id: '2|10',
        color: 'white',
      },
      {
        id: '2|11',
        color: 'white',
      },
      {
        id: '2|12',
        color: 'white',
      },
      {
        id: '2|13',
        color: 'white',
      },
      {
        id: '2|14',
        color: 'white',
      },
      {
        id: '2|15',
        color: 'white',
      },
      {
        id: '3|0',
        color: 'white',
      },
      {
        id: '3|1',
        color: 'white',
      },
      {
        id: '3|2',
        color: 'white',
      },
      {
        id: '3|3',
        color: 'white',
      },
      {
        id: '3|4',
        color: 'white',
      },
      {
        id: '3|5',
        color: 'black',
      },
      {
        id: '3|6',
        color: 'yellow',
      },
      {
        id: '3|7',
        color: 'yellow',
      },
      {
        id: '3|8',
        color: 'yellow',
      },
      {
        id: '3|9',
        color: 'yellow',
      },
      {
        id: '3|10',
        color: 'black',
      },
      {
        id: '3|11',
        color: 'white',
      },
      {
        id: '3|12',
        color: 'white',
      },
      {
        id: '3|13',
        color: 'white',
      },
      {
        id: '3|14',
        color: 'white',
      },
      {
        id: '3|15',
        color: 'white',
      },
      {
        id: '4|0',
        color: 'white',
      },
      {
        id: '4|1',
        color: 'black',
      },
      {
        id: '4|2',
        color: 'black',
      },
      {
        id: '4|3',
        color: 'black',
      },
      {
        id: '4|4',
        color: 'black',
      },
      {
        id: '4|5',
        color: 'yellow',
      },
      {
        id: '4|6',
        color: 'yellow',
      },
      {
        id: '4|7',
        color: 'yellow',
      },
      {
        id: '4|8',
        color: 'yellow',
      },
      {
        id: '4|9',
        color: 'yellow',
      },
      {
        id: '4|10',
        color: 'yellow',
      },
      {
        id: '4|11',
        color: 'black',
      },
      {
        id: '4|12',
        color: 'black',
      },
      {
        id: '4|13',
        color: 'black',
      },
      {
        id: '4|14',
        color: 'black',
      },
      {
        id: '4|15',
        color: 'white',
      },
      {
        id: '5|0',
        color: 'white',
      },
      {
        id: '5|1',
        color: 'black',
      },
      {
        id: '5|2',
        color: 'yellow',
      },
      {
        id: '5|3',
        color: 'yellow',
      },
      {
        id: '5|4',
        color: 'yellow',
      },
      {
        id: '5|5',
        color: 'yellow',
      },
      {
        id: '5|6',
        color: 'black',
      },
      {
        id: '5|7',
        color: 'yellow',
      },
      {
        id: '5|8',
        color: 'yellow',
      },
      {
        id: '5|9',
        color: 'black',
      },
      {
        id: '5|10',
        color: 'yellow',
      },
      {
        id: '5|11',
        color: 'yellow',
      },
      {
        id: '5|12',
        color: 'yellow',
      },
      {
        id: '5|13',
        color: 'yellow',
      },
      {
        id: '5|14',
        color: 'black',
      },
      {
        id: '5|15',
        color: 'white',
      },
      {
        id: '6|0',
        color: 'white',
      },
      {
        id: '6|1',
        color: 'white',
      },
      {
        id: '6|2',
        color: 'black',
      },
      {
        id: '6|3',
        color: 'yellow',
      },
      {
        id: '6|4',
        color: 'yellow',
      },
      {
        id: '6|5',
        color: 'yellow',
      },
      {
        id: '6|6',
        color: 'black',
      },
      {
        id: '6|7',
        color: 'yellow',
      },
      {
        id: '6|8',
        color: 'yellow',
      },
      {
        id: '6|9',
        color: 'black',
      },
      {
        id: '6|10',
        color: 'yellow',
      },
      {
        id: '6|11',
        color: 'yellow',
      },
      {
        id: '6|12',
        color: 'yellow',
      },
      {
        id: '6|13',
        color: 'black',
      },
      {
        id: '6|14',
        color: 'white',
      },
      {
        id: '6|15',
        color: 'white',
      },
      {
        id: '7|0',
        color: 'white',
      },
      {
        id: '7|1',
        color: 'white',
      },
      {
        id: '7|2',
        color: 'white',
      },
      {
        id: '7|3',
        color: 'black',
      },
      {
        id: '7|4',
        color: 'yellow',
      },
      {
        id: '7|5',
        color: 'yellow',
      },
      {
        id: '7|6',
        color: 'black',
      },
      {
        id: '7|7',
        color: 'yellow',
      },
      {
        id: '7|8',
        color: 'yellow',
      },
      {
        id: '7|9',
        color: 'black',
      },
      {
        id: '7|10',
        color: 'yellow',
      },
      {
        id: '7|11',
        color: 'yellow',
      },
      {
        id: '7|12',
        color: 'black',
      },
      {
        id: '7|13',
        color: 'white',
      },
      {
        id: '7|14',
        color: 'white',
      },
      {
        id: '7|15',
        color: 'white',
      },
      {
        id: '8|0',
        color: 'white',
      },
      {
        id: '8|1',
        color: 'white',
      },
      {
        id: '8|2',
        color: 'white',
      },
      {
        id: '8|3',
        color: 'white',
      },
      {
        id: '8|4',
        color: 'black',
      },
      {
        id: '8|5',
        color: 'yellow',
      },
      {
        id: '8|6',
        color: 'yellow',
      },
      {
        id: '8|7',
        color: 'yellow',
      },
      {
        id: '8|8',
        color: 'yellow',
      },
      {
        id: '8|9',
        color: 'yellow',
      },
      {
        id: '8|10',
        color: 'yellow',
      },
      {
        id: '8|11',
        color: 'black',
      },
      {
        id: '8|12',
        color: 'white',
      },
      {
        id: '8|13',
        color: 'white',
      },
      {
        id: '8|14',
        color: 'white',
      },
      {
        id: '8|15',
        color: 'white',
      },
      {
        id: '9|0',
        color: 'white',
      },
      {
        id: '9|1',
        color: 'white',
      },
      {
        id: '9|2',
        color: 'white',
      },
      {
        id: '9|3',
        color: 'black',
      },
      {
        id: '9|4',
        color: 'yellow',
      },
      {
        id: '9|5',
        color: 'yellow',
      },
      {
        id: '9|6',
        color: 'yellow',
      },
      {
        id: '9|7',
        color: 'yellow',
      },
      {
        id: '9|8',
        color: 'yellow',
      },
      {
        id: '9|9',
        color: 'yellow',
      },
      {
        id: '9|10',
        color: 'yellow',
      },
      {
        id: '9|11',
        color: 'yellow',
      },
      {
        id: '9|12',
        color: 'black',
      },
      {
        id: '9|13',
        color: 'white',
      },
      {
        id: '9|14',
        color: 'white',
      },
      {
        id: '9|15',
        color: 'white',
      },
      {
        id: '10|0',
        color: 'white',
      },
      {
        id: '10|1',
        color: 'white',
      },
      {
        id: '10|2',
        color: 'white',
      },
      {
        id: '10|3',
        color: 'black',
      },
      {
        id: '10|4',
        color: 'yellow',
      },
      {
        id: '10|5',
        color: 'yellow',
      },
      {
        id: '10|6',
        color: 'yellow',
      },
      {
        id: '10|7',
        color: 'yellow',
      },
      {
        id: '10|8',
        color: 'yellow',
      },
      {
        id: '10|9',
        color: 'yellow',
      },
      {
        id: '10|10',
        color: 'yellow',
      },
      {
        id: '10|11',
        color: 'yellow',
      },
      {
        id: '10|12',
        color: 'black',
      },
      {
        id: '10|13',
        color: 'white',
      },
      {
        id: '10|14',
        color: 'white',
      },
      {
        id: '10|15',
        color: 'white',
      },
      {
        id: '11|0',
        color: 'white',
      },
      {
        id: '11|1',
        color: 'white',
      },
      {
        id: '11|2',
        color: 'black',
      },
      {
        id: '11|3',
        color: 'yellow',
      },
      {
        id: '11|4',
        color: 'yellow',
      },
      {
        id: '11|5',
        color: 'yellow',
      },
      {
        id: '11|6',
        color: 'yellow',
      },
      {
        id: '11|7',
        color: 'yellow',
      },
      {
        id: '11|8',
        color: 'yellow',
      },
      {
        id: '11|9',
        color: 'yellow',
      },
      {
        id: '11|10',
        color: 'yellow',
      },
      {
        id: '11|11',
        color: 'yellow',
      },
      {
        id: '11|12',
        color: 'yellow',
      },
      {
        id: '11|13',
        color: 'black',
      },
      {
        id: '11|14',
        color: 'white',
      },
      {
        id: '11|15',
        color: 'white',
      },
      {
        id: '12|0',
        color: 'white',
      },
      {
        id: '12|1',
        color: 'white',
      },
      {
        id: '12|2',
        color: 'black',
      },
      {
        id: '12|3',
        color: 'yellow',
      },
      {
        id: '12|4',
        color: 'yellow',
      },
      {
        id: '12|5',
        color: 'yellow',
      },
      {
        id: '12|6',
        color: 'yellow',
      },
      {
        id: '12|7',
        color: 'black',
      },
      {
        id: '12|8',
        color: 'black',
      },
      {
        id: '12|9',
        color: 'yellow',
      },
      {
        id: '12|10',
        color: 'yellow',
      },
      {
        id: '12|11',
        color: 'yellow',
      },
      {
        id: '12|12',
        color: 'yellow',
      },
      {
        id: '12|13',
        color: 'black',
      },
      {
        id: '12|14',
        color: 'white',
      },
      {
        id: '12|15',
        color: 'white',
      },
      {
        id: '13|0',
        color: 'white',
      },
      {
        id: '13|1',
        color: 'black',
      },
      {
        id: '13|2',
        color: 'yellow',
      },
      {
        id: '13|3',
        color: 'yellow',
      },
      {
        id: '13|4',
        color: 'yellow',
      },
      {
        id: '13|5',
        color: 'black',
      },
      {
        id: '13|6',
        color: 'black',
      },
      {
        id: '13|7',
        color: 'white',
      },
      {
        id: '13|8',
        color: 'white',
      },
      {
        id: '13|9',
        color: 'black',
      },
      {
        id: '13|10',
        color: 'black',
      },
      {
        id: '13|11',
        color: 'yellow',
      },
      {
        id: '13|12',
        color: 'yellow',
      },
      {
        id: '13|13',
        color: 'yellow',
      },
      {
        id: '13|14',
        color: 'black',
      },
      {
        id: '13|15',
        color: 'white',
      },
      {
        id: '14|0',
        color: 'white',
      },
      {
        id: '14|1',
        color: 'black',
      },
      {
        id: '14|2',
        color: 'black',
      },
      {
        id: '14|3',
        color: 'black',
      },
      {
        id: '14|4',
        color: 'black',
      },
      {
        id: '14|5',
        color: 'white',
      },
      {
        id: '14|6',
        color: 'white',
      },
      {
        id: '14|7',
        color: 'white',
      },
      {
        id: '14|8',
        color: 'white',
      },
      {
        id: '14|9',
        color: 'white',
      },
      {
        id: '14|10',
        color: 'white',
      },
      {
        id: '14|11',
        color: 'black',
      },
      {
        id: '14|12',
        color: 'black',
      },
      {
        id: '14|13',
        color: 'black',
      },
      {
        id: '14|14',
        color: 'black',
      },
      {
        id: '14|15',
        color: 'white',
      },
      {
        id: '15|0',
        color: 'white',
      },
      {
        id: '15|1',
        color: 'white',
      },
      {
        id: '15|2',
        color: 'white',
      },
      {
        id: '15|3',
        color: 'white',
      },
      {
        id: '15|4',
        color: 'white',
      },
      {
        id: '15|5',
        color: 'white',
      },
      {
        id: '15|6',
        color: 'white',
      },
      {
        id: '15|7',
        color: 'white',
      },
      {
        id: '15|8',
        color: 'white',
      },
      {
        id: '15|9',
        color: 'white',
      },
      {
        id: '15|10',
        color: 'white',
      },
      {
        id: '15|11',
        color: 'white',
      },
      {
        id: '15|12',
        color: 'white',
      },
      {
        id: '15|13',
        color: 'white',
      },
      {
        id: '15|14',
        color: 'white',
      },
      {
        id: '15|15',
        color: 'white',
      },
    ],
  },
];

export default draws;
